import {
  GATEWAY,
  buidlURL,
  fetchRequest,
  invokeOnce,
  navigateWithPOST
} from '@/api';

const state = {
  direction: null,
  query: '',
  checkinDate: null,
  checkoutDate: null,
  adults: 2,
  children: [],
  list: {
    regions: [],
    hotels: []
  },
  nightsAdults: '',
  currencyText: 'руб.',
  office: null,
  client: null,
  sent: false,
  purchased: false,
  officeCities: [],
  officeList: [],
  isMinified: false,
  invoiceId: null,
  partnerOrderId: null,
  wait: {
    processing: 'Подождите, идет бронирование'
  },
  soldOut: false,
  bookError: false
};

const dateToString = date =>
  `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
    '0' + date.getDate()
  ).slice(-2)}`;

const i18n = {
  month: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  day: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
};
const getLocaleDate = date => {
  return [
    date.getDate(),
    i18n.month[date.getMonth()].slice(0, 3).toLowerCase()
    // date.getFullYear()
  ].join(' ');
};

const getters = {
  checkin: state => {
    if (!state.checkinDate) return;
    return dateToString(state.checkinDate);
  },
  checkout: state => {
    if (!state.checkoutDate) return;
    return dateToString(state.checkoutDate);
  },
  checkInOut: state => {
    return state.checkoutDate
      ? `${getLocaleDate(state.checkinDate)} - ${getLocaleDate(
          state.checkoutDate
        )}`
      : '';
  },
  toLocalePrice: (state /* , getters, __, rootGetters */) => price => {
    return `${Math.ceil(price).toLocaleString('ru-Ru')} ${state.currencyText}`;
    // return `${Math.ceil(
    //   rootGetters.context === 'office' ? getters.price(price) : price
    // ).toLocaleString('ru-Ru')} ${state.currencyText}`;
  },
  price: (/* _, __, ___, rootGetters */) => price => {
    return price;
    // return rootGetters.context === 'office' ? parseFloat(price) + 33.9 : price;
  }
};
const actions = {
  getQueryList({ commit, state }) {
    return invokeOnce(() => {
      const url = buidlURL(GATEWAY, {
        type: 'multicomplete',
        query: state.query,
        lang: 'ru'
      });
      fetchRequest(url, response => {
        commit(
          'updateQueryList',
          response.error
            ? {
                regions: [],
                hotels: []
              }
            : response.result
        );
      });
    }, 250);
  },

  setStateFromUri({ commit }, query) {
    return new Promise(resolve => {
      const { adults, checkin, checkout, ...params } = query;
      const parseDate = dateString => {
        const [year, month, day] = dateString.split('-');
        return new Date(year, month - 1, day);
      };
      const newState = {
        checkinDate: parseDate(checkin),
        checkoutDate: parseDate(checkout),
        adults: parseInt(adults, 10)
      };

      if (params.region_id) {
        const options = {
          type: 'regions',
          limit: 1,
          lang: 'ru'
        };
        if (params.region_id > 1) {
          options.last_id = params.region_id - 1;
        }
        const url = buidlURL(GATEWAY, options);
        fetchRequest(url, response => {
          const {
            country_ru,
            country_code,
            id,
            name_ru,
            type
          } = response.result[0];
          newState.direction = {
            country: country_ru,
            country_code,
            id,
            name: name_ru,
            type,
            params
          };
          commit('updateStateFromUri', newState);
          commit('updateNightsAdults');
        }).then(() => resolve());
      } else {
        const url = buidlURL(GATEWAY, { type: 'hotelinfodb', ...params });
        fetchRequest(url, response => {
          //
          // TO DO
          // optimize method hotelinfodb
          
          // console.log(response.result[0]);

          if (response.result.length === 0) {
            const url = buidlURL(GATEWAY, {
              type: 'hotelinfo',
              ...params
            });
            return fetchRequest(url, response => {
              newState.direction = {
                params,
                name: response.result[0].name,
                id: response.result[0].id,
                region_name: response.result[0].city
              };
              commit('updateStateFromUri', newState);
              commit('updateNightsAdults');
              resolve();
            });
          }

          newState.direction = {
            params,
            name: response.result[0].name,
            id: response.result[0].id,
            region_name: response.result[0].city || response.result[0].region.name
          };
          commit('updateStateFromUri', newState);
          commit('updateNightsAdults');
          resolve();
        });
      }
    });
  },
  sendClientData({ commit }, { client, room, office, context }) {
    commit('updateClientData', client);
    const url = buidlURL(GATEWAY, {
      type: 'feedback',
      client: JSON.stringify(client),
      office,
      room: JSON.stringify(room),
      context
    });
    fetchRequest(url, response => {
      if (response.result === 'ok') {
        commit('responseAfterFeedback');
        setTimeout(() => commit('responseAfterFeedback', false), 5000);
      }
    });
  },
  getOfficeList({ commit, rootGetters }) {
    const url = buidlURL(GATEWAY, {
      type: rootGetters.context === 'main' ? 'officelist' : 'officelistpm'
    });
    fetchRequest(url, response => {
      commit('updateOfficeList', response);
    });
  },
  getInvoiceId({ commit }) {
    const url = buidlURL(GATEWAY, {
      type: 'invoiceid'
    });
    return fetchRequest(url, response => {
      // console.log(response);
      commit('updateInvoiceId', response.result);
    });
  },
  dropInvoiceId({ commit }, id) {
    const url = buidlURL(GATEWAY, {
      type: 'dropinvoiceid',
      id
    });
    return fetchRequest(url, () => {
      commit('updateInvoiceId');
    });
  },
  approveInvoice({ commit, dispatch }, { id, data }) {
    const url = buidlURL(GATEWAY, {
      type: 'updateinvoice',
      id,
      data: JSON.stringify(data)
    });
    commit('setLoading', state.wait.processing, {
      root: true
    });
    return fetchRequest(url, response => {
      commit('updatePartnerOrderId', response.result.partner_order_id);
      if (response.result.status === 'processing') {
        const urlStatus = buidlURL(GATEWAY, {
          type: 'orderstatus',
          partner_order_id: response.result.partner_order_id
        });
        const waitWhileProcessing = () =>
          fetchRequest(urlStatus, response => {
            // console.log(response);
            if (response.result !== null) {
              // console.log('ok');
              if (response.result.status === 'processing') {
                return setTimeout(() => {
                  waitWhileProcessing();
                }, 1000);
              }
              if (response.result.status === 'ok') {
                commit('setLoading', state.wait.processing, {
                  root: true
                });
                commit('updateClientData', data.client);
                dispatch('finalizePurchase', JSON.stringify(data));
                return commit('responseAfterPurchase');
              }
            }
            if (response.error !== null) {
              dispatch('abortPurchase');
              if (response.error.slug === 'validation_invalid_params') {
                commit('throwValidationError');
              } else if (
                response.error.extra &&
                response.error.extra.errors &&
                response.error.extra.errors[0] &&
                response.error.extra.errors[0].error === 'soldout'
              ) {
                commit('updateSoldOut');
              } else commit('throwUnknownError');
              commit('setLoading', state.wait.processing, {
                root: true
              });
            }
          });
        waitWhileProcessing();
      }
    });
  },

  finalizePurchase({ state }, data) {
    const url = buidlURL(GATEWAY, {
      type: 'finalizepurchase',
      id: state.partnerOrderId,
      data
    });
    return fetchRequest(url);
  },

  abortPurchase({ state }) {
    const url = buidlURL(GATEWAY, {
      type: 'abortpurchase',
      id: state.partnerOrderId
    });
    return fetchRequest(url);
  },

  copyToOffice(_, params) {
    navigateWithPOST(
      `${
        process.env.NODE_ENV !== 'production'
          ? 'https://office.well.ru'
          : location.origin
      }/tours_insert/hotel.php?whs`,
      params
    );
  }
};
const mutations = {
  updateQuery(state, query, final = false) {
    if (!final) state.direction = null;
    state.query = query;
  },
  updateStateFromUri(state, newState) {
    Object.assign(state, newState);
  },
  updateQueryList(state, list) {
    state.list =
      state.query.length > 0
        ? {
          regions: list.regions.filter((region) => region.type === 'City'),
          hotels: list.hotels,
        }
        : {
            regions: [],
            hotels: []
          };
  },
  updateDirection(state, direction) {
    state.list = {
      regions: [],
      hotels: []
    };

    if (!direction) {
      state.direction = null;
      return;
    }
    state.direction = direction;
    state.query = direction.name;
  },
  // updateLocation(state, location) {
  //   state.location = location;
  // },
  updateNightsAdults(state) {
    const nights = (state.checkoutDate - state.checkinDate) / 86400000;
    const guests = state.adults + state.children.length;
    const nightsString = nights === 1 ? 'ночь' : nights < 5 ? 'ночи' : 'ночей';
    const guestsString = guests === 1 ? 'гостя' : 'гостей';
    state.nightsAdults = `за ${nights} ${nightsString} для ${guests} ${guestsString}`;
  },
  updateCheckIn(state, date) {
    if (!date) state.checkinDate = null;
    state.checkinDate = date;
    state.checkoutDate = null;
  },
  updateCheckOut(state, date) {
    if (state.checkinDate.getTime() < date.getTime()) state.checkoutDate = date;
    else {
      state.checkoutDate = state.checkinDate;
      state.checkinDate = date;
    }
  },
  updateAdults(state, index) {
    state.adults += index;
  },
  updateChildren(state, index) {
    if (index > 0) state.children.push(0);
    else state.children.pop();
  },
  updateChildAge(state, { index, age }) {
    state.children.splice(index, 1, age);
  },
  updateClientData(state, client) {
    state.client = client;
  },
  updateOfficeList(state, response) {
    state.officeCities = response.result.cities;
    state.officeList = response.result.offices;
  },
  updateInvoiceId(state, id = null) {
    state.invoiceId = id;
  },
  responseAfterFeedback(state, sent = true) {
    state.sent = sent;
  },
  responseAfterPurchase(state) {
    state.purchased = true;
  },
  minify(state, setMinified = true) {
    if (setMinified) state.isMinified = true;
    else state.isMinified = false;
  },
  updatePartnerOrderId(state, id) {
    state.partnerOrderId = id;
  },
  updateSoldOut(state) {
    state.soldOut = true;
    // console.log('soldout error');
  },
  throwValidationError(state) {
    state.bookError = true;
    // console.log('validation error');
  },
  throwUnknownError(state) {
    state.bookError = true;
    // console.log('unknown error');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
